import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import styles from "./certificateTemplate.module.scss";
import FormikControl from "../../../components/formComponents/FormikControl";
import i18next from "i18next";
import { Form, Formik } from "formik";
import { getDropDownValue, generalValidationMessage } from "../../../config/appConfig";
import { previewCertificateTemplate, getTemplateSectionbyId, saveCertifciateMail } from "../../../services/APIService";
import { useApiErrorModalContext } from "../../../errorHandling/ApiErrorModalContext";
import _ from "lodash";
import ReactQuill from "react-quill";
import FooterButtonSection from "../../../components/footerSection/FooterButtonSection";
import PreviewCertificateTemplate from "./PreviewCertificateTemplate";
import CustomModalDialog from "../../../components/modal/CustomModalDialog";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { getContentLineCount } from "../../../utils/commonFuntion";

const CeritificateTemplate = (props) => {
  const { setOpenSnackbar } = props;
  const templateList = [
    {
      key: "100% onderhouden",
      value: 1,
    },
    {
      key: "BOVAG Onderhoudsvrij",
      value: 2,
    },
    {
      key: "BOVAG Import Tellercheck",
      value: 3,
    },
    {
      key: "BOVAG-Garantie",
      value: 4,
    },
    {
      key: "Keurmerk5",
      value: 5,
    },
    {
      key: "Gecombineerd",
      value: 6,
    },
  ];

  const setDropdownValue = (value, dropdownOptions, name, formikProps) => {
    let selectedOption = getDropDownValue(value, dropdownOptions);

    formikProps.setFieldValue(name, selectedOption);
    formikProps.setFieldTouched(name, false);
  };

  const defaultValues = {
    template: null,
    isShowWarning: false,
    // title: "",
    block1: "",
    block2: "",
    block3: "",
    block4: "",
    block5: "",
    block6: "",
  };

  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  const charLimitErroObj = {
    block1: false,
    block2: false,
    block3: false,
    block4: false,
    block5: false,
    block6: false

  }
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [initalValue, setInitalValue] = useState(defaultValues);
  const [certificateTemplate, setCertificateTemplate] = useState("");
  const [buttonName, setButtonName] = useState("");
  const [preview, setPreview] = useState(false);
  const [previousValue, setPreviousValue] = useState("");
  const [charLimitError, setCharLimitError] = useState(charLimitErroObj);

  const validationSchema = Yup.object().shape({
    template: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
  });


  const handleSubmit = (values) => {
    if (buttonName === "save") {
      handleSave(values);
    } else if (buttonName === "preview") {
      certificateTemplateAPI(
        values.template.value,
        values.block1,
        values.block2,
        values.block3,
        values.block4,
        values.block5,
        values.block6
      )
      setPreview(true);
    } else {
      setButtonName("");
    }
  };

  const modules = {
    toolbar: [['bold', 'italic', 'underline'], [{ list: "bullet" }], ["link"]],
    clipboard: {
      matchVisual: false,
    },
  };
  const formats = ["bold", "italic", "underline", "list", "link"];

  const certificateTemplateAPI = (certificateId, block1, block2, block3,block4, block5, block6) => {
    setCertificateTemplate("");
    previewCertificateTemplate({ 
      certificateId: certificateId, 
      block1: block1,
      block2: block2,
      block3: block3,
      block4: block4,
      block5: block5,
      block6: block6,
     })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setApiErrorModalState({ error: response });
        } else {
          setCertificateTemplate(response.pdfUrl);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const handleSave = (values) => {
    let payload = {
      certificate_Id: _.get(values, "template.value", ""),
      isShowWarning: _.get(values, "isShowWarning", false),
      isEmailTemplate: false,
      section1: _.get(values, "block1", ""),
      section2: _.get(values, "block2", ""),
      section3: _.get(values, "block3", ""),
      section4: _.get(values, "block4", ""),
      section5: _.get(values, "block5", ""),
      section6: _.get(values, "block6", ""),
      // title: _.get(values, "title", ""),
      isEmailBlock: false,
    };
    saveCertifciateMail(payload)
      .then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true) === false) {
          _.set(response, "status", 200);
          setApiErrorModalState({
            error: response,
          });
        } else {
          setOpenSnackbar(true);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  }
  const [templateId, setTemplateId] = useState(templateList[0]);
  useEffect(() => {
    getTemplateSectionbyId({ CertificateId: templateId?.value, isEmailBlock: false })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setInitalValue({
            template: null,
            isShowWarning: false,
            block1: "",
            block2: "",
            block3: "",
            block4: "",
            block5: "",
            block6: "",
          });
          setApiErrorModalState({ error: response });
        } else {
          setInitalValue({
            template: templateId,
            block1: response?.section1,
            block2: response?.section2,
            block3: response?.section3,
            block4: response?.section4,
            block5: response?.section5,
            block6: response?.section6,
            isShowWarning: _.get(response, 'warningStatus', false),
          });
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId]);

  const handleChange = (e, formikProps, fieldname, maxLines) => {
    const charLimitErrorObj = { ...charLimitError };
    const totalLines = getContentLineCount(e);
    console.log("totalLines=", totalLines);
    if (totalLines > maxLines && e.length > previousValue.length) {
      formikProps.setFieldValue(fieldname, previousValue);
      _.set(charLimitErrorObj, fieldname, true);
      setCharLimitError(charLimitErrorObj);
    } else if (totalLines > maxLines) {
      formikProps.setFieldValue(fieldname, e);
      _.set(charLimitErrorObj, fieldname, true);
      setCharLimitError(charLimitErrorObj);
    } else {
      setPreviousValue(e);
      _.set(charLimitErrorObj, fieldname, false);
      formikProps.setFieldValue(fieldname, e);
      setCharLimitError(charLimitErrorObj);
    }
  };

  const showComponentforAllCertificate = (formikProps, modules, formats) => {
    return (
      <Box>
        <Box className={styles.blockWrapper1}>
          <label className={styles.labelText}>
            {i18next.t("Block 1")}
          </label>
          <ReactQuill
            theme="snow"
            id="block1"
            className={styles.blockTextBox}
            value={formikProps.values.block1}
            onChange={(e) => handleChange(e, formikProps, "block1", 8)}
            modules={modules}
            formats={formats}
          />
          {charLimitError?.block1 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
        </Box>

      </Box>
    )
  }

  const showComponentforCombinedCertificate = (formikProps, modules, formats) => {
    return (
      <>
        {/* <Box className={styles.blockWrapper1}>
          <label className={styles.labelText}>
            {i18next.t("Certificate Title")}
          </label>
          <FormikControl
            control="textfield"
            type="text"
            size="small"
            variant="filled"
            label="Certificate Title"
            id="title"
            name="title"
            isHideLabel
            placeholder={i18next.t(
              "Enter the value"
            )}
            onChange={(e) => {
              let value = _.get(e, "target.value", "");
              formikProps?.setFieldValue("title", value);
            }}
            value={formikProps?.values.title}
          />
        </Box> */}
        <Box className={styles.blockContainer}>
          <Box className={styles.blockWrapper1}>
            <label className={styles.labelText}>
              {i18next.t("BOVAG Garantie")}
            </label>
            <ReactQuill
              theme="snow"
              id="block1"
              className={styles.blockTextBox}
              value={formikProps.values.block1}
              onChange={(e) => handleChange(e, formikProps, "block1", 3)}
              modules={modules}
              formats={formats}
            />
            {charLimitError?.block1 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
          </Box>
          <Box className={styles.blockWrapper1}>
            <label className={styles.labelText}>
              {i18next.t("BOVAG Onderhoudsvrij")}
            </label>
            <ReactQuill
              theme="snow"
              id="block2"
              className={styles.blockTextBox}
              value={formikProps.values.block2}
              onChange={(e) => handleChange(e, formikProps, "block2", 3)}
              modules={modules}
              formats={formats}
            />
            {charLimitError?.block2 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
          </Box>
          <Box className={styles.blockWrapper1}>
            <label className={styles.labelText}>
              {i18next.t("BOVAG Import Tellercheck")}
            </label>
            <ReactQuill
              theme="snow"
              id="block3"
              className={styles.blockTextBox}
              value={formikProps.values.block3}
              onChange={(e) => handleChange(e, formikProps, "block3", 3)}
              modules={modules}
              formats={formats}
            />
            {charLimitError?.block3 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
          </Box>
          <Box className={styles.blockWrapper1}>
            <label className={styles.labelText}>
            {i18next.t("100% onderhouden")}
            </label>
            <ReactQuill
              theme="snow"
              id="block4"
              className={styles.blockTextBox}
              value={formikProps.values.block4}
              onChange={(e) => handleChange(e, formikProps, "block4", 3)}
              modules={modules}
              formats={formats}
            />
            {charLimitError?.block4 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
          </Box>
          <Box className={styles.blockWrapper1}>
            <label className={styles.labelText}>
              {i18next.t("Keurmerk5")}
            </label>
            <ReactQuill
              theme="snow"
              id="block5"
              className={styles.blockTextBox}
              value={formikProps.values.block5}
              onChange={(e) => handleChange(e, formikProps, "block5", 3)}
              modules={modules}
              formats={formats}
            />
            {charLimitError?.block5 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
          </Box>
          <Box className={styles.blockWrapper1}>
            <label className={styles.labelText}>
              {i18next.t("Certificate footer")}
            </label>
            <ReactQuill
              theme="snow"
              id="block6"
              className={styles.blockTextBox}
              value={formikProps.values.block6}
              onChange={(e) => handleChange(e, formikProps, "block6", 5)}
              modules={modules}
              formats={formats}
            />
            {charLimitError?.block6 ? <Box className={styles.errorMessage}>{i18next.t("character limit exceeded")}</Box> : ""}
          </Box>

        </Box>
      </>
    )
  }

  return (
    <>
      <Box className={styles.emailTextWrapper} data-testid="CeritificateTemplate">
        {i18next.t("Certificate Template")}
      </Box>
      <Box className={styles.emailWrapper}>
        <Formik
          enableReinitialize={true}
          initialValues={initalValue}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (

            <Form onSubmit={formikProps.handleSubmit}>
              {previousValue === "" ? setPreviousValue(formikProps.values.block1) : ""}
              <Box className={styles.blockWrapper1}>
                <Box className="textboxDoubleWraper">
                  <Box className={styles.blockWrapper1}>
                    <label className={styles.labelText}>
                      {i18next.t("Select template")}
                    </label>

                    <FormikControl
                      variant="filled"
                      control="autocomplete"
                      label=""
                      options={templateList}
                      hiddenLabel
                      id="template"
                      name="template"
                      size="small"
                      isSelect={true}
                      disabled={false}
                      getOptionDisabled={false}
                      placeholder={i18next.t("Select one")}
                      className="input-grp__box select"
                      freeSolo={false}
                      onChange={(e, value) => {
                        setDropdownValue(
                          value,
                          templateList,
                          "template",
                          formikProps
                        );
                        setInitalValue({
                          template: value,
                          isShowWarning: false,
                          block1: "",

                        });
                        setTemplateId(value);
                      }}
                      value={formikProps?.values.template}
                      hasError={
                        !!(
                          formikProps?.touched.template &&
                          formikProps?.errors.template
                        )
                      }
                      error={
                        !!(
                          formikProps?.touched.template &&
                          formikProps?.errors.template
                        )
                      }
                      errorMessage={formikProps?.errors?.template}
                    />
                  </Box>

                  <Box className={styles.switchButton}>
                    <FormikControl
                      variant="filled"
                      control="switch"
                      label="Warning no provider"
                      id="isShowWarning"
                      name="isShowWarning"
                      isHideLabel={true}
                      checked={formikProps?.values.isShowWarning}
                      className="input-grp__box select"
                      onChange={(e) => {
                        formikProps.setFieldValue("isShowWarning", e.target.checked);
                      }}
                      value={formikProps?.values.isShowWarning}
                      hasError={
                        !!(
                          formikProps?.touched.isShowWarning &&
                          formikProps?.errors.isShowWarning
                        )
                      }
                      error={
                        !!(
                          formikProps?.touched.isShowWarning &&
                          formikProps?.errors.isShowWarning
                        )
                      }
                      errorMessage={formikProps?.errors?.isShowWarning}
                    />
                  </Box>
                </Box>

                <Box className="textboxDoubleWraper">
                  {templateId?.value === 6 ? showComponentforCombinedCertificate(formikProps, modules, formats) :
                    showComponentforAllCertificate(formikProps, modules, formats)}

                  <Box className={styles.buttonmarging}>

                    <FooterButtonSection
                      footerStyle={styles.buttonWrapper}
                      btnlist={[
                        {
                          title: "Preview",
                          iconStyle: "",
                          buttonType:
                            "muibtn-secondary-with-border-without-icon",
                          attriType: "button",
                          withIcon: false,
                          showCountSection: false,
                          count: 0,
                          handleClick: () => {
                            setButtonName("preview");
                            setPreview(true)
                            formikProps.handleSubmit();
                          },
                          isDisabled: false,
                        },
                        {
                          title: "Save",
                          iconStyle: "",
                          buttonType: "muibtn-primary",
                          attriType: "button",
                          withIcon: false,
                          showCountSection: false,
                          count: 0,
                          handleClick: () => {
                            setButtonName("save");
                            formikProps.handleSubmit();
                          },
                          isDisabled:
                            formikProps.values.block1 ===
                            defaultValues.block1,
                        },
                      ]}
                    />
                  </Box>
                </Box>

              </Box>

              {!_.isEmpty(certificateTemplate) ? (
                <CustomModalDialog
                  title={formikProps.values.template?.key}
                  isShow={preview}
                  onClose={() => setPreview(false)}
                  className={"settingEmail"}
                  isCloseButton={true}
                  hasFooter={false}
                >
                  <PreviewCertificateTemplate
                    certificateTemplate={certificateTemplate}
                  />
                </CustomModalDialog>
              ) : null}
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default CeritificateTemplate;
CeritificateTemplate.propTypes = {
  setOpenSnackbar: PropTypes.any
}